import {Component, OnInit} from '@angular/core';
import {provideNativeDateAdapter} from '@angular/material/core';
import {Business} from '../models/business.model';
import {BusinessService} from '../_service/business.service';

@Component({
  selector: 'app-integrations',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.css',
})
export class IntegrationsComponent implements OnInit {
  configList: any;
  staffName: string;
  business: Business;
  accessibleMode: boolean = false;



  constructor(private businessService: BusinessService) {
    this.business = businessService.getBusiness();
    this.staffName = businessService.getLoginResponse().staffName;
    this.configList = this.businessService.getConfigList();
  }

  ngOnInit() {
  }
}
